//@flow
import React, {useMemo} from 'react';
import {
  FormControlLabel,
  Checkbox,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {BLOG_FORM_FIELDS} from '../../../../constants';
import {useFormContext} from 'react-hook-form';
import FormField from '../../FormField';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import {useStoreDomain} from '../../../../../store/utils';
import {colors} from '../../../../../../assets/styles/colors';
import {stringToSafeLink} from '../../../../../../utils/string';
import {
  useCurrentBlogPost,
  useBlogFormDraftValue,
} from '../../../../utils/blog-post';
import {InfoOutlined} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  urlLabel: {
    fontSize: '14px',
    color: colors.grey700,
    marginBottom: '.125rem',
    whiteSpace: 'nowrap',
  },
  urlInputContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.5fr',
    gap: '.5rem',
  },

  tooltip: {
    marginLeft: theme.spacing(2),
    backgroundColor: '#F4F4F6',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0px 4px 2rem rgba(0, 0, 0, 0.125)',
  },
  textTooltip: {
    textAlign: 'left!important',
    color: ' #717190',
    fontSize: '12px',
    '& span': {
      marginLeft: theme.spacing(1),
    },
  },
  infoBtn: {
    color: '#9595AB',
  },
  inputAdornment: {
    whiteSpace: 'nowrap',
  },
}));

export default function UrlField() {
  const {domain} = useStoreDomain();
  const classes = useStyles();

  const {updateDraft} = useBlogFormDraftValue();

  const {register, watch, errors, setValue} = useFormContext();

  const currentBlog = useCurrentBlogPost();

  const watchTitle = watch(BLOG_FORM_FIELDS.title);
  const watchUrlIsCustom = watch(BLOG_FORM_FIELDS.urlIsCustom);
  const watchUrl = watch(BLOG_FORM_FIELDS.url);

  const titleSlug = useMemo(() => stringToSafeLink(watchTitle || ''), [
    watchTitle,
  ]);

  return (
    <FormField title="4. URL de dirección">
      <div className={classes.urlLabelContainer}>
        <span className={classes.urlLabel}>Predeterminado</span>
        <CustomTextField
          value={`https://${domain.domainName}/blog/${
            currentBlog ? currentBlog.id : '<Identificador>'
          }/${titleSlug}`}
          fullWidth
          disabled
          InputProps={{
            endAdornment: !currentBlog && (
              <Tooltip
                placement="left"
                enterTouchDelay={0}
                classes={{tooltip: classes.tooltip}}
                title={
                  <Typography className={classes.textTooltip}>
                    El <strong>{'<Identificador>'}</strong> se reemplazará
                    automáticamente por un identificador único de tu blog
                    después de crear el blog.
                  </Typography>
                }
              >
                <InfoOutlined color="primary" className={classes.infoBtn} />
              </Tooltip>
            ),
          }}
        />
      </div>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              name={BLOG_FORM_FIELDS.urlIsCustom}
              onChange={e => {
                setValue(BLOG_FORM_FIELDS.urlIsCustom, e.target.checked);

                updateDraft({
                  [BLOG_FORM_FIELDS.urlIsCustom]: e.target.checked,
                });
              }}
              color="primary"
              checked={!!watchUrlIsCustom}
            />
          }
          label="Personalizar URL"
          classes={{
            label: classes.urlLabel,
          }}
        />

        {!!watchUrlIsCustom && (
          <div className={classes.urlInputContainer}>
            <CustomTextField
              value={`https://${domain.domainName}/blog/${
                currentBlog ? currentBlog.id : '<Identificador>'
              }/`}
              disabled
            />
            <CustomTextField
              fullWidth
              name={BLOG_FORM_FIELDS.url}
              inputRef={register({
                required: 'Este campo es requerido',
              })}
              value={watchUrl}
              onChange={e => {
                const slug = stringToSafeLink(e.target.value);
                setValue(BLOG_FORM_FIELDS.url, slug);
              }}
              onBlur={e => {
                updateDraft({
                  [BLOG_FORM_FIELDS.url]: e.target.value,
                });
              }}
              error={!!errors[BLOG_FORM_FIELDS.url]}
              helperText={
                errors[BLOG_FORM_FIELDS.url] &&
                errors[BLOG_FORM_FIELDS.url].message
              }
            />
          </div>
        )}
      </div>
    </FormField>
  );
}
